import {
  Http
} from '@/model/Http.js'

export default class sort extends Http {
  // 订单排名
  getOrderList(data){
    const url = 'api/rank/search-rank'
    return this.postAjax(url, {
      ...data
    })
  }

  // 佣金排名
  getCommissionList(data){
    const url = 'api/rank/commission-rank'
    return this.postAjax(url, {
      ...data
    })
  }

  // 团队排名
  getTeamList(data){
    const url = 'api/rank/team-rank'
    return this.postAjax(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/sort.js